import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

export interface ServerExtensionState {
  extension?: object;
  channel?: object;
  viewer_extension?: object;
  viewer?: object;
}

@Module({ namespaced: true, name: 'extension_state' })
export default class ExtensionStateStore extends VuexModule {
  public extension: object = {};
  public channel: object = {};
  public viewerExtension: object = {};
  public viewerChannel: object = {};

  @Mutation
  public setExtensionState(extensionState: object) {
    this.extension = extensionState;
  }

  @Mutation
  public setChannelState(channelState: object) {
    this.channel = channelState;
  }

  @Mutation
  public setViewerExtensionState(viewerState: object) {
    this.viewerExtension = viewerState;
  }

  @Mutation
  public setViewerChannelState(viewerState: object) {
    this.viewerChannel = viewerState;
  }

  @Mutation
  public setAllState(serverState: ServerExtensionState) {
    this.extension = serverState.extension || {};
    this.channel = serverState.channel || {};
    this.viewerExtension = serverState.viewer_extension || {};
    this.viewerChannel = serverState.viewer || {};
  }
}
